// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"EquipmentsNew_paginationPageDropdownWrap__2U2Xf","container":"EquipmentsNew_container__aaMkf"};